import React, { Component } from "react";
import { connect } from "react-redux";
import { signOut } from "../../user/actions";

import logo from "../../../assets/images/logo-blue.png";
import Layout from "../../shared/containers/BaseLayout";
import Loading from "../../shared/components/misc/FullScreenLoading";
import DownloadRequirementsCard from "../components/DownloadRequirementsCard";
import RejectionCard from "../components/RejectionCard";
import ChatSupportCard from "../components/ChatSupportCard";

import { TrackEventName } from '../../shared/constants/SegmentEvents';
import { segmentEventTracker } from '../../../utils/SegmentEventTracker';
import { hasAnyRejectedRequirements } from '../misc/CustomerStatus'

export class PreKYCScreen extends Component {
  logoutUser = () => {
    segmentEventTracker.trackEvent(TrackEventName.LOGOUT_CLICKED);
    this.props.signOut();
  }

  isRejected = () => {
    const { user } = this.props;
    return hasAnyRejectedRequirements(user);
  }

  render() {
    if (this.props.loading) return <Loading />;

    return(
      <Layout>
        <nav className="pre-kyc-nav _backgroundColor-sh000 _padding--normal _horizontalPadding--large">
          <img src={logo} alt="FC logo" />
          <a
            dataTestId="go-back-btn"
            className="ds-btn --small _outline -secondary _padding--small-mobileOnly _fontSize--xsmall-mobileOnly"
            href='http://www.firstcircle.ph'
          >
            Go To Homepage
          </a>
        </nav>


        <div className="grid --narrow _marginTop--epic-tabletUp">
          { this.isRejected() ? <RejectionCard /> : <DownloadRequirementsCard /> }
          <ChatSupportCard />

          <div className="_textAlign_center">
            <a
              className="ds-btn --small _outline -secondary _padding--small-mobileOnly _fontSize--xsmall-mobileOnly"
              data-test="log-out-button"
              onClick={this.logoutUser}
              style={{ 'display': 'inline-block' }}
            >
              Log out
            </a>
          </div>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.shared.ui.loading.default,
    user: state.user,
    businessTrustPass: state.business_trustpass,
    personalTrustPass: state.personal_trustpass,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    signOut: () => dispatch(signOut()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreKYCScreen);



// WEBPACK FOOTER //
// ./src/features/home/containers/PreKYCScreen.js